export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PageHeader.vue?vue&type=template&id=7f233e00&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageHeader.vue?vue&type=template&id=7f233e00&scoped=true&
// module id = 116
// module chunks = 0